import { updateSmartList as _updateSmartList } from '@griply/services';
import {
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';
import { UpdateSmartList } from 'shared/types/smart-list';

export const updateSmartList = async (
  uid: ID,
  smartList: UpdateSmartList,
): Promise<void> =>
  _updateSmartList({
    smartList,
    db: getFirestore(),
    doc,
    updateDoc,
    serverTimestamp,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateSmartList,
        error,
        uid,
        docPath: `smart-lists/${smartList.id}`,
      }),
  });
